//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.VehicleDesign.js";
import "../no/TaggedObject.js";
import "../Features/Features.SelectFeature.js";
import "../no/SelectObject.js";
let d=[[[0,"EyeDefinitionType",1,0],[0,"EyeFeature",1,"Features.Feature",0],[0,"EyellipsePercentile",1,0],[0,"PivotPoint",1,"Point",0],[0,"PointV1",1,"Point",0],[0,"PointV2",1,"Point",0],[1,"SelectEyellipse",0,"Features.SelectFeature",0]],[[[],"EyeIllustration",{},0,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Features.VehicleDesign.EyeDefinitionBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VehicleDesign.EyeDefinitionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VehicleDesign.EyeDefinitionBuilder.EyeDefinition = Object.freeze({
    "EyeFeature" : "EyeFeature", "BySelectingPivotPoint" : "BySelectingPivotPoint", "ClosestPointtoAPillarSection" : "ClosestPointtoAPillarSection", "V1Point" : "V1Point", "V2Point" : "V2Point"});

SPLM.Features.VehicleDesign.EyeDefinitionBuilder.EyePercentile = Object.freeze({
    "Per95" : "Per95", "Per99" : "Per99"});

export default SPLM;